import { call, takeEvery, put } from 'redux-saga/effects';
import {
    fetchAuthURL,
    callbackLogin,
    loginCheck,
} from './service';
import {
    ActionTypes,
    ActionPayload,
    authURLRecieved,
    loginCallbackError,
    initiateLoginError,
    loginCallbackSuccess,
    sessionCheckSuccess,
    sessionCheckError,
} from '../../store/app/actions';

export function* initiateLogin(action: ActionPayload) {
    console.log(action);

    try {
        const response = yield call(fetchAuthURL, action.payload.loginURL);
        if (response) {
            yield put(authURLRecieved(response))
            window.location = response
        } else {
            yield put(initiateLoginError());
        }
    } catch(err) {
        yield put(initiateLoginError());
    }
}

export function* loginCallback() {

    try {
        const response = yield call(callbackLogin);
        if (response) {
            yield put(loginCallbackSuccess(response));
        } else {
            yield put(loginCallbackError());
        }
    } catch(err) {
        yield put(loginCallbackError());
    }
}

export function* checkSession() {

    try {
        const response = yield call(loginCheck);
        if (response) {
            yield put(sessionCheckSuccess(response));
        } else {
            yield put(sessionCheckError());
        }
    } catch(err) {
        yield put(sessionCheckError());
    }
}

export function* loginSaga() {
    yield takeEvery(ActionTypes.LOGIN_INITIATED, initiateLogin);
    yield takeEvery(ActionTypes.LOGIN_CALLBACK, loginCallback);
    yield takeEvery(ActionTypes.SESSION_CHECK_INITIATED, checkSession);
}
